import React from 'react';
import styled from '@emotion/styled';
import { TelephoneState } from '../TelephonePopoverButton';
import { TelephoneAlert } from 'components/views/atoms/TelephoneAlert';
import { TelephoneButton } from 'components/views/molecules/Cockpit/TelephoneButton';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';

const ButtonWrapper = styled.div({
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
});

type Props = {
    tag: string;
    state: TelephoneState;
    size?: SizeProp;
    onClick?: () => void;
}

export const TelephoneButtonWithAlert = ({ tag, state, size, onClick }: Props) => {
    return (
        <ButtonWrapper>
            {state === 'ringing' && <TelephoneAlert variant="outlined" severity="error">{tag}</TelephoneAlert>}
            <TelephoneButton onClick={onClick} size={size} state={state} />
        </ButtonWrapper>
    );
};
